import { useEffect } from 'react';

export const useRemoveScrollLock = (isEnabled: boolean) => {
  useEffect(() => {
    if (!isEnabled) return;

    const removeScrollLock = () => {
      document.body.removeAttribute('data-scroll-locked');
    };

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'data-scroll-locked') {
          const scrollLocked = document.body.getAttribute('data-scroll-locked');
          if (scrollLocked === '1') {
            removeScrollLock();
          }
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-scroll-locked'],
    });

    if (document.body.getAttribute('data-scroll-locked') === '1') {
      removeScrollLock();
    }

    return () => {
      observer.disconnect();
    };
  }, [isEnabled]);
};
